module.exports = __webpack_public_path__ + "static/sport/bgi-form.0951acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-form.png
// module id = rUIr
// module chunks = 0